import { User } from '../types/api';

export const permissions = {
  userManagement: {
    view: 'View_User_Management',
    createUser: 'Create_User',
    editUser: 'Edit_User',
    deleteUser: 'Delete_User',
    viewRoles: 'View_Role_Management',
    createRole: 'Create_Role',
    editRole: 'Edit_Role',
    deleteRole: 'Delete_Role',
    viewPermissions: 'View_Permission_Management',
    createPermission: 'Create_Permission',
    editPermission: 'Edit_Permission',
    deletePermission: 'Delete_Permission',
  },
  costLibrary: {
    view: 'View_Cost_Library',
    create: 'Create_Cost_Library_Item',
    edit: 'Edit_Cost_Library_Item',
    delete: 'Delete_Cost_Library_Item',
  },
  masterData: {
    view: 'View_Master_Data',
    create: 'Create_Master_Data',
    edit: 'Edit_Master_Data',
    delete: 'Delete_Master_Data',
    viewDxfRules: 'View_Dxf_Rules',
    createDxfRules: 'Create_Dxf_Rules',
    editDxfRules: 'Edit_Dxf_Rules',
    deleteDxfRules: 'Delete_Dxf_Rules',
  },
  projects: {
    view: 'View_Projects',
    create: 'Create_Projects',
    edit: 'Edit_Projects',
    delete: 'Delete_Projects',
  },
  estimates: {
    view: 'View_Estimates',
    create: 'Create_Estimates',
    edit: 'Edit_Estimates',
    delete: 'Delete_Estimates',
  },
  documentArchives: {
    view: 'View_Document_Archives',
    create: 'Create_Document_Archives',
    edit: 'Edit_Document_Archives',
    delete: 'Delete_Document_Archives',
    configureVault: 'Configure_Document_Archive_Vault',
  },
} as const;

export function hasPermission(user: User | null, permission: string): boolean {
  if (!user) return false;
  return (user.permissions ?? []).includes(permission);
}

export function hasAnyPermission(user: User | null, required: string[]): boolean {
  if (!user) return false;
  if (required.length === 0) return true;
  const granted = new Set(user.permissions ?? []);
  return required.some((permission) => granted.has(permission));
}
